import { createSelector } from '@reduxjs/toolkit';

export const type = createSelector(
	(state) => state?.financial?.navigation,
	(value) => value?.type ?? null,
);
